import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <h1 className="font-display text-3xl font-bold mb-4">Customers</h1>
      <div className="card-flat overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr><th className="text-left p-3">Name</th><th className="text-left p-3">Email</th><th className="text-left p-3">Phone</th><th className="text-left p-3">Joined</th></tr>
          </thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.id} className="border-t border-slate-100">
                <td className="p-3 font-semibold">{c.name}</td><td className="p-3">{c.email}</td><td className="p-3">{c.phone || "-"}</td><td className="p-3 text-slate-500 text-xs">{c.created_at?.slice(0,10)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan="4" className="p-10 text-center text-slate-500">No customers yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
